export default {"src":"/_next/static/media/icon_play_friends.6be206e9.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};